module.exports = __webpack_public_path__ + "img/tobalas.41d881cf.jpg";